export const docRestrictionsApi = {
    getUploadDocRestrict: 'v1/api/uploadDocRestrict',
    addUploadDocRestrict: 'v1/api/uploadDocRestrict',
    updateUploadDocRestrict: 'v1/api/uploadDocRestrict',
    deleteUploadDocRestrict: 'v1/api/uploadDocRestrict',
}